export default "__VITE_ASSET__moGbvovH__"